var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "products-card"
  }, [_c('div', {
    staticClass: "card__head"
  }, [_c('swiper', {
    ref: _vm.ref,
    attrs: {
      "options": _vm.swiperOption
    },
    on: {
      "slideChange": _vm.handleSlide
    }
  }, _vm._l(_vm.groupBuying.product.images, function (image) {
    return _c('swiper-slide', {
      key: image.id
    }, [_c('img', {
      attrs: {
        "src": image.pic_url
      }
    })]);
  }), 1), _c('div', {
    staticClass: "page"
  }, [_vm._v(" " + _vm._s(_vm.activeIndex) + "/" + _vm._s(_vm.groupBuying.product.images.length) + " ")]), _vm.groupBuying.product.images.length > 1 ? [_c('div', {
    staticClass: "product-swiper-button-prev",
    class: 'product-swiper-button-prev_' + _vm.groupBuying.id
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512",
      "width": "17",
      "height": "17"
    }
  }, [_c('path', {
    attrs: {
      "d": "M109.3 288L480 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-370.7 0 73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288z"
    }
  })])]), _c('div', {
    staticClass: "product-swiper-button-next",
    class: 'product-swiper-button-next_' + _vm.groupBuying.id
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512",
      "width": "17",
      "height": "17"
    }
  }, [_c('path', {
    attrs: {
      "d": "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"
    }
  })])])] : _vm._e()], 2), _c('div', {
    staticClass: "card__body"
  }, [_c('div', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.groupBuying.title))]), _c('div', {
    staticClass: "card__desc",
    staticStyle: {
      "white-space": "pre-line"
    }
  }, [_vm._v(" " + _vm._s(_vm.groupBuying.description) + " ")]), _c('div', {
    staticClass: "card__split-line my-3"
  }), _c('div', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.groupBuying.product.title))]), _c('div', {
    staticClass: "card__desc",
    staticStyle: {
      "white-space": "pre-line"
    }
  }, [_vm._v(" " + _vm._s(_vm.groupBuying.product.description) + " ")])]), _c('div', {
    staticClass: "card__footer"
  }, [_c('div', {
    staticClass: "card__line"
  }), [_vm.groupBuying.show_total_amount ? _c('div', {
    staticClass: "card__row"
  }, [_c('div', {
    staticClass: "card__row--name"
  }, [_vm._v("目前團購數量")]), _c('div', [_c('span', {
    staticClass: "card__row--volume"
  }, [_vm._v(_vm._s(_vm.groupBuying.current_quantity + _vm.groupBuying.adjust_quantity))]), _vm._v("組 ")])]) : _vm._e(), _c('div', {
    staticClass: "card__row"
  }, [_c('div', [_vm._v("集氣截止日期")]), _c('div', [_vm._v(_vm._s(_vm.endDate))])]), _c('div', {
    staticClass: "card__actions"
  }, [_c('button', {
    staticClass: "s-btn s-liff-theme-btn-outline s-btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.isExpired || _vm.isSoldOut
    },
    on: {
      "click": _vm.shareGroupBuying
    }
  }, [_vm._v(" 分享好友 ")]), _c('button', {
    staticClass: "s-btn s-liff-theme-btn s-btn-sm",
    attrs: {
      "type": "button",
      "disabled": !_vm.canSubmit || _vm.isExpired || _vm.isSoldOut
    },
    on: {
      "click": _vm.handleTogroupBuying
    }
  }, [_vm._v(" " + _vm._s(_vm.submitMessage) + " ")])])]], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }